/* eslint-disable */

import axios from "axios";
import moment from "moment";

// const url = require("../../client_config/config").url;
const shareUrl = require("../../client_config/config").shareUrl;

const state = {
  items: [],
  link: {},
  dialog: false,
};

const getters = {
  isLoading: (state) => state.loading,
};

const actions = {
  async getItem({ commit }, id) {
    commit("SET_LOADING", true);
    try {
      const response = await axios.get(`${shareUrl}/${id}`);
      if (response.data.success) {
        commit("SET_ALL", response.data);
        commit("SET_LOADING", false);
        return response.data;
      }
    } catch (error) {
      console.log(error);
      return error.response;
    }
  },

  async getLinkInfo({ commit }, id) {
    try {
      const response = await axios.get(`${shareUrl}/code/${id}`);
      if (response.data.success) {
        commit("SET_LINK", response.data);
        return response.data;
      }
    } catch (error) {
      console.log(error);
      return error.response;
    }
  },

  async addItem({ commit }, data) {
    try {
      const response = await axios.post(`${shareUrl}`, data);
      commit("ADD_ITEM", response.data);
      return response.data;
    } catch (error) {
      return error.response;
    }
  },
};

const mutations = {
  SET_ALL(state, data) {
    state.items = data;
  },
  SET_LINK(state, data) {
    state.link = data;
  },
  ADD_ITEM(state, data) {
    state.items.push(data);
  },

  SET_DIALOG(state, data) {
    state.dialog = data;
  },

  SET_LOADING(state, data) {
    state.loading = data;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
